import type { FieldState } from './NewPassword';
import {
  fieldState,
  findErrors,
  Tones,
  getTone,
  minimumLength,
} from './validation';

/**
 * single point for all validations
 * @returns {tone:'', message:''}
 */
export const passwordValidations = (
  password: string,
  forbiddenString: string,
  t: any,
): FieldState => {
  if (!password) {
    return fieldState(Tones.Neutral);
  }

  const tone = getTone(password);

  let errors = null;
  const minLengthMessage = t(`${minimumLength} characters or more`, {
    min: minimumLength,
  });

  errors = findErrors(password, minLengthMessage, forbiddenString, t);

  if (errors) {
    return fieldState(Tones.Critical, errors);
  }

  if (tone === Tones.Positive) {
    return fieldState(Tones.Positive, t('Strong password, nice one!'));
  }
  return fieldState(Tones.Neutral, t('Okay, but could be stronger'));
};
